// extracted by mini-css-extract-plugin
export default {"container":"Table_container__3DJRs","table-container":"Table_table-container__Gd-Ob","back":"Table_back__wJSiZ","button-wrapper":"Table_button-wrapper__aRyyw"};